import { render, staticRenderFns } from "./indexV2.vue?vue&type=template&id=6434b048&scoped=true&"
import script from "./indexV2.vue?vue&type=script&lang=js&"
export * from "./indexV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434b048",
  null
  
)

export default component.exports